if ($('.popup-youtube').length > 0) {
    $('.js-popup-youtube').magnificPopup({
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
            open: function () {
                return new YT.Player('magnificPlayer', {
                    events: {
                        'onReady': function (event) {
                            event.target.playVideo();
                        },
                        'onStateChange': function (event) {
                            switch (event.data) {
                                case YT.PlayerState.ENDED:
                                    if (window.__youtube_callback) {
                                        $(window.__youtube_callback).modal();
                                    }
                                    return $.magnificPopup.close();
                            }
                        }
                    }
                });
            }
        }
    });
}